<template>
  <v-menu
    v-model="showUserSelectionMenu"
    bottom
    :close-on-content-click="false"
    min-width="auto"
    offset-y
    right
    transition="scale-transition"
  >
    <template #activator="menu">
      <v-tooltip
        bottom
      >
        <template #activator="tooltip">
          <v-btn
            ref="usersListButton"
            class="px-0"
            :disabled="isLoading"
            height="48"
            outlined
            text
            v-bind="{ ...menu.attrs, ...tooltip.attrs }"
            v-on="{ ...menu.on, ...tooltip.on }"
          >
            <v-badge
              bottom
              class="user-selection-menu-badge"
              :color="colorForUserListButtonBadge"
              :content="selectedUsers.length.toString()"
              left
              overlap
            >
              <v-icon>
                mdi-account-multiple-outline
              </v-icon>
            </v-badge>
            <v-icon class="ml-1 mr-n3">
              mdi-menu-down
            </v-icon>
          </v-btn>
        </template>
        <span>Add / Remove Participants</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-text-field
        v-model="searchInput"
        class="pa-2 pb-0"
        clearable
        dense
        :disabled="isLoading"
        hide-details
        outlined
      />
      <v-list
        class="overflow-y-auto"
        dense
        :disabled="isLoading"
        max-height="40vh"
      >
        <v-list-item-group
          v-model="selectedUsers"
          multiple
        >
          <v-list-item
            v-for="item of filteredUsers"
            v-show="!item.hidden"
            :key="item.value"
            :value="item.value"
          >
            <template #default="{ active }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                />
              </v-list-item-action>
              <UserSelectListItem :user="item" />
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import UserSelectListItem from './UserSelectListItem.vue'

export default {
  name: 'UserSelectMenu',
  components: { UserSelectListItem },
  inheritAttrs: false,

  model: {
    prop: 'users',
    event: 'change',
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    open: {
      type: Boolean,
      default: false,
    },

    userList: {
      type: Array,
      required: true,
    },

    users: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      lazyIsOpen: false,
      lazyUsers: undefined,
      searchInput: '',
    }
  },

  computed: {
    colorForUserListButtonBadge () {
      return this.selectedUsers.length ? 'primary' : 'red'
    },

    filteredUsers () {
      const searchText = (this.searchInput || '').trim().toLowerCase()

      return this.userList.map(u => {
        return {
          ...u,
          hidden: searchText && u.text.toLowerCase().indexOf(searchText) < 0,
        }
      })
    },

    isLoading () { return this.loading },

    selectedUsers: {
      get () { return this.lazyUsers || [] },

      set (value) {
        this.lazyUsers = value
        this.$emit('change', value)
      },
    },

    showUserSelectionMenu: {
      get () { return this.lazyIsOpen },

      set (value) {
        this.lazyIsOpen = value
        this.$emit('update:open', value)
        if (this.lazyIsOpen) this.searchInput = ''
      },
    },
  },

  watch: {
    open (value) {
      this.lazyIsOpen = value
    },

    users (value) {
      this.lazyUsers = value || []
    },
  },

  created () {
    this.lazyIsOpen = this.open
    this.lazyUsers = this.users || []
  },

  methods: {
  },
}
</script>

<style scoped>
.user-selection-menu-badge {
  .v-badge__badge {
    font-size: 11px;
    padding: 2px;
    height: 14px;
    min-width: 14px;
  }
}
</style>
